import { render } from "./CustomSelectOneSystemRole.vue?vue&type=template&id=3cba7252"
import script from "./CustomSelectOneSystemRole.vue?vue&type=script&lang=js"
export * from "./CustomSelectOneSystemRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__